module.exports = __webpack_public_path__ + "media/images/young-tom-morris.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/young-tom-morris.jpg
// module id = 76
// module chunks = 0